var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGemPink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 9.97599C20.0047 11.9558 19.4217 13.8925 18.3247 15.5407C17.2277 17.1889 15.6662 18.4743 13.8379 19.2342C12.0097 19.994 9.99703 20.1941 8.05498 19.809C6.11294 19.4239 4.32892 18.471 2.92895 17.0711C1.52898 15.6711 0.576073 13.8871 0.190987 11.945C-0.194098 10.003 0.00594193 7.99032 0.765796 6.16208C1.52565 4.33384 2.8111 2.77229 4.45927 1.67531C6.10744 0.578325 8.04418 -0.00472473 10.024 2.88365e-05C12.6698 2.88365e-05 15.2072 1.05106 17.0781 2.92192C18.949 4.79277 20 7.3302 20 9.97599Z",
    fill: "url(#paint0_radial_116_5203)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0244 1.34595C9.27775 1.43693 8.53863 1.58153 7.81279 1.77864C7.09271 1.97268 6.3861 2.21358 5.69743 2.49979C5.09862 2.95206 4.53602 3.45037 4.01475 3.99018C3.47402 4.5036 2.98305 5.067 2.5484 5.67287C2.24042 6.35311 1.9989 7.06154 1.82724 7.78825C1.60919 8.50086 1.46419 9.2338 1.39453 9.97575C1.4658 10.7254 1.61075 11.4661 1.82724 12.1873C2.00298 12.9128 2.24436 13.6209 2.5484 14.3027C2.98305 14.9085 3.47402 15.4719 4.01475 15.9854C4.53469 16.5193 5.09746 17.0097 5.69743 17.4517C6.38194 17.7488 7.08935 17.99 7.81279 18.1729C8.53583 18.3818 9.2759 18.5266 10.0244 18.6056C10.7645 18.5239 11.4963 18.3791 12.2118 18.1729C12.9353 17.99 13.6427 17.7488 14.3272 17.4517C14.9272 17.0097 15.49 16.5193 16.0099 15.9854C16.5506 15.4719 17.0416 14.9085 17.4763 14.3027C17.7803 13.6209 18.0217 12.9128 18.1974 12.1873C18.4139 11.4661 18.5588 10.7254 18.6301 9.97575C18.5604 9.2338 18.4155 8.50086 18.1974 7.78825C18.0258 7.06154 17.7842 6.35311 17.4763 5.67287C17.0416 5.067 16.5506 4.5036 16.0099 3.99018C15.4886 3.45037 14.926 2.95206 14.3272 2.49979C13.6386 2.21358 12.9319 1.97268 12.2118 1.77864C11.4935 1.58419 10.7626 1.43962 10.0244 1.34595Z",
    fill: "#FF8FC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0238 3.43677C9.46103 3.50576 8.90579 3.62647 8.36515 3.79735C7.81377 3.92587 7.27482 4.10284 6.75458 4.3262C6.29733 4.66438 5.87098 5.04246 5.48055 5.456C5.07392 5.84451 4.69631 6.2623 4.35074 6.706C4.14206 7.23167 3.96545 7.76953 3.82189 8.31658C3.67087 8.86087 3.55842 9.41512 3.48535 9.97523C3.55842 10.5353 3.67087 11.0896 3.82189 11.6339C3.96545 12.1809 4.14206 12.7188 4.35074 13.2445C5.05291 14.1391 5.85997 14.9461 6.75458 15.6483C7.27898 15.8605 7.81705 16.0372 8.36515 16.1772C8.90944 16.3282 9.46371 16.4406 10.0238 16.5137C10.5836 16.4386 11.1377 16.3262 11.6824 16.1772C12.2295 16.0336 12.7674 15.857 13.293 15.6483C13.7017 15.3358 14.1824 14.855 14.543 14.5185C14.9505 14.1222 15.3281 13.6964 15.6728 13.2445C15.8922 12.7227 16.0691 12.1841 16.2017 11.6339C16.3497 11.0874 16.4701 10.5338 16.5623 9.97523C16.4701 9.41663 16.3497 8.86305 16.2017 8.31658C16.0691 7.76635 15.8922 7.22773 15.6728 6.706C15.3341 6.25659 14.956 5.83827 14.543 5.456C14.1557 5.04815 13.7378 4.67046 13.293 4.3262C12.7713 4.10682 12.2327 3.92995 11.6824 3.79735C11.1405 3.63146 10.5857 3.51085 10.0238 3.43677Z",
    fill: "url(#paint1_radial_116_5203)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48055 5.45673C5.87098 5.04319 6.29732 4.66511 6.75458 4.32693L5.69688 2.5C5.09807 2.95226 4.53547 3.45058 4.0142 3.99039C3.47347 4.50381 2.9825 5.06721 2.54785 5.67307L4.35074 6.70673C4.69631 6.26303 5.07392 5.84524 5.48055 5.45673Z",
    fill: "url(#paint2_radial_116_5203)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.77938 4.32672C7.29962 4.10337 7.83857 3.92639 8.38995 3.79787C8.93059 3.62699 9.48582 3.50629 10.0486 3.43729V1.34595C9.302 1.43693 8.56292 1.58153 7.83707 1.77864C7.11699 1.97268 6.41034 2.21358 5.72168 2.49979L6.77938 4.32672Z",
    fill: "url(#paint3_radial_116_5203)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0244 18.6052V16.5138C10.5838 16.4364 11.1377 16.324 11.683 16.1773C12.2301 16.0337 12.768 15.8571 13.2936 15.6484L14.3273 17.4513C13.6428 17.7484 12.9353 17.9896 12.2119 18.1725C11.4964 18.3787 10.7646 18.5235 10.0244 18.6052Z",
    fill: "url(#paint4_radial_116_5203)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3266 17.4511L13.293 15.6482C13.7016 15.3357 14.1824 14.855 14.5429 14.5184C14.9504 14.1221 15.328 13.6963 15.6728 13.2444L17.4756 14.3021C17.041 14.9079 16.55 15.4713 16.0093 15.9848C15.4893 16.5187 14.9266 17.0091 14.3266 17.4511Z",
    fill: "url(#paint5_radial_116_5203)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4757 14.3025L15.6729 13.2448C15.8922 12.7231 16.0691 12.1845 16.2017 11.6342C16.3497 11.0878 16.4701 10.5342 16.5623 9.97559H18.6296C18.5583 10.7252 18.4134 11.4659 18.1969 12.1871C18.0212 12.9127 17.7798 13.6207 17.4757 14.3025Z",
    fill: "url(#paint6_radial_116_5203)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6296 9.97574H16.5623C16.4701 9.41714 16.3497 8.86355 16.2017 8.31709C16.0691 7.76686 15.8922 7.22824 15.6729 6.70651L17.4757 5.67285C17.7837 6.35309 18.0252 7.06152 18.1969 7.78824C18.4149 8.50084 18.5599 9.23378 18.6296 9.97574Z",
    fill: "url(#paint7_radial_116_5203)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4756 5.67307L15.6728 6.70673C15.334 6.25732 14.9559 5.839 14.5429 5.45673C14.1556 5.04888 13.7378 4.67119 13.293 4.32693L14.3266 2.5C14.9254 2.95226 15.488 3.45058 16.0093 3.99039C16.55 4.50381 17.041 5.06721 17.4756 5.67307Z",
    fill: "url(#paint8_radial_116_5203)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3273 2.49979L13.2936 4.32672C12.7719 4.10734 12.2333 3.93048 11.683 3.79787C11.1419 3.62902 10.5868 3.50835 10.0244 3.43729V1.34595C10.7627 1.43962 11.4936 1.58419 12.2119 1.77864C12.932 1.97268 13.6386 2.21358 14.3273 2.49979Z",
    fill: "url(#paint9_radial_116_5203)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0242 18.6052V16.5138C9.46409 16.4408 8.90982 16.3283 8.36554 16.1773C7.81743 16.0373 7.27936 15.8606 6.75496 15.6484L5.69727 17.4513C6.38177 17.7484 7.08919 17.9896 7.81262 18.1725C8.53566 18.3814 9.27574 18.5262 10.0242 18.6052Z",
    fill: "url(#paint10_radial_116_5203)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69688 17.4511L6.75458 15.6482C5.85997 14.9461 5.05291 14.139 4.35074 13.2444L2.54785 14.3021C2.9825 14.9079 3.47347 15.4713 4.0142 15.9848C4.53414 16.5187 5.09691 17.0091 5.69688 17.4511Z",
    fill: "url(#paint11_radial_116_5203)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5484 14.3025L4.35129 13.2448C4.14261 12.7191 3.966 12.1813 3.82244 11.6342C3.67142 11.0899 3.55897 10.5357 3.4859 9.97559H1.39453C1.4658 10.7252 1.61075 11.4659 1.82724 12.1871C2.00298 12.9127 2.24436 13.6207 2.5484 14.3025Z",
    fill: "url(#paint12_radial_116_5203)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.39453 9.97574H3.4859C3.55897 9.41563 3.67142 8.86138 3.82244 8.31709C3.966 7.77003 4.14261 7.23218 4.35129 6.70651L2.5484 5.67285C2.24042 6.35309 1.9989 7.06152 1.82724 7.78824C1.60919 8.50084 1.46419 9.23378 1.39453 9.97574Z",
    fill: "url(#paint13_radial_116_5203)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69688 2.5C5.89006 2.94154 5.94604 3.43097 5.85758 3.90473C5.76912 4.3785 5.54028 4.81473 5.20079 5.15682C4.86129 5.4989 4.42683 5.73104 3.95375 5.8231C3.48067 5.91516 2.99085 5.86289 2.54785 5.67307L4.35074 6.70673C4.69631 6.26303 5.07392 5.84524 5.48055 5.45673C5.87098 5.04319 6.29732 4.66511 6.75458 4.32693L5.69688 2.5Z",
    fill: "url(#paint14_radial_116_5203)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.65,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5484 5.67285C2.92998 5.9614 3.21676 6.35725 3.37208 6.80972C3.52741 7.2622 3.54419 7.75074 3.42028 8.21281C3.29637 8.67488 3.0374 9.08947 2.67653 9.40352C2.31565 9.71758 1.86928 9.91681 1.39453 9.97574H3.4859C3.55897 9.41563 3.67142 8.86138 3.82244 8.31709C3.966 7.77003 4.14261 7.23218 4.35129 6.70651L2.5484 5.67285Z",
    fill: "url(#paint15_radial_116_5203)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.39453 9.97559C3.48588 9.97559 4.80802 12.9804 3.07725 13.99L4.35129 13.2448C4.14261 12.7191 3.966 12.1813 3.82244 11.6342C3.67142 11.0899 3.55897 10.5357 3.4859 9.97559H1.39453Z",
    fill: "url(#paint16_radial_116_5203)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3266 17.4511C14.1408 17.0106 14.0906 16.5248 14.1824 16.0556C14.2741 15.5864 14.5037 15.1553 14.8418 14.8172C15.1798 14.4792 15.6109 14.2496 16.0801 14.1579C16.5493 14.0661 17.0351 14.1163 17.4756 14.3021L15.6728 13.2444C15.328 13.6963 14.9504 14.1221 14.5429 14.5184C14.1824 14.855 13.7016 15.3357 13.293 15.6482L14.3266 17.4511Z",
    fill: "url(#paint17_radial_116_5203)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4757 14.3025C17.0857 14.0163 16.7911 13.6191 16.6305 13.1629C16.4698 12.7066 16.4505 12.2124 16.5751 11.745C16.6998 11.2776 16.9626 10.8587 17.3291 10.543C17.6956 10.2273 18.1488 10.0296 18.6296 9.97559H16.5623C16.4701 10.5342 16.3497 11.0878 16.2017 11.6342C16.0691 12.1845 15.8922 12.7231 15.6729 13.2448L17.4757 14.3025Z",
    fill: "url(#paint18_radial_116_5203)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6296 9.975C16.5623 9.975 15.2161 6.9702 16.9469 5.98462L15.6729 6.70577C15.8922 7.22751 16.0691 7.76612 16.2017 8.31635C16.3497 8.86282 16.4701 9.4164 16.5623 9.975H18.6296Z",
    fill: "url(#paint19_radial_116_5203)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99052 3.62981C7.42802 3.62981 6.58669 3.62981 5.69727 2.5L6.75496 4.32693C7.27521 4.10357 7.81415 3.9266 8.36554 3.79808L8.99052 3.62981Z",
    fill: "url(#paint20_radial_116_5203)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0576 16.3215C12.6201 16.3215 13.4615 16.3215 14.3268 17.4513L13.2932 15.6484C12.7675 15.8571 12.2297 16.0337 11.6826 16.1773L11.0576 16.3215Z",
    fill: "url(#paint21_radial_116_5203)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.39054 10.1679C3.58134 11.1664 3.85471 12.1473 4.20784 13.1006V13.2688L3.75114 13.6294L4.40015 13.2448C4.19147 12.7191 4.01487 12.1813 3.8713 11.6342C3.72029 11.0899 3.60783 10.5357 3.53476 9.97558C3.60783 9.41548 3.72029 8.86122 3.8713 8.31693C4.01487 7.76988 4.19147 7.23203 4.40015 6.70635C4.74572 6.26265 5.12334 5.84487 5.52996 5.45635C5.92039 5.04281 6.34674 4.66473 6.80399 4.32655C7.32424 4.10319 7.86318 3.92622 8.41457 3.7977L9.37613 3.55732C8.5601 3.65819 7.7553 3.83524 6.97228 4.08616L6.77997 4.01405C6.44343 3.50924 6.08287 3.00443 5.74633 2.47559L6.53957 4.13424V4.27847C5.71797 4.88232 4.98911 5.60308 4.37612 6.41789H4.2319L2.59727 5.57655L4.1117 6.58616V6.73039C3.71577 7.6743 3.45676 8.66994 3.34249 9.68712H3.22229L3.34249 9.80731L3.39054 10.1679Z",
    fill: "#FFC7D7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8171 13.4378L17.4037 14.2551C16.8989 13.9186 16.3941 13.6301 15.9133 13.2936V13.1494C16.2402 12.1753 16.4972 11.1792 16.6825 10.1686L16.8027 10.0484L16.6825 9.9282C16.6169 9.69891 16.5367 9.47409 16.4422 9.25513C16.4422 9.54359 16.5623 9.85609 16.6104 10.1205C16.5182 10.6791 16.3979 11.2327 16.2498 11.7792C16.1172 12.3294 15.9404 12.868 15.721 13.3897C15.3763 13.8417 14.9987 14.2675 14.5912 14.6638C14.2306 15.0003 13.7498 15.4811 13.3412 15.7936L12.1152 16.2022C12.4889 16.1369 12.8582 16.0486 13.221 15.9378H13.3652L14.1585 17.1638L13.5095 15.8657V15.6974C14.3028 15.053 15.0351 14.3368 15.697 13.558H15.8412L15.8171 13.4378Z",
    fill: "#FFC7D7"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37417 13.2452L10.0472 9.97602L4.37417 6.70679C4.1655 7.23246 3.98889 7.77031 3.84533 8.31737C3.69431 8.86166 3.58185 9.41591 3.50879 9.97602C3.58185 10.5361 3.69431 11.0904 3.84533 11.6347C3.98889 12.1817 4.1655 12.7196 4.37417 13.2452Z",
    fill: "url(#paint22_radial_116_5203)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 6.706L10.0481 9.97523V3.43677C9.48529 3.50576 8.93005 3.62647 8.38942 3.79735C7.83803 3.92587 7.29909 4.10284 6.77884 4.3262C6.32159 4.66438 5.89524 5.04246 5.50481 5.456C5.09819 5.84451 4.72057 6.2623 4.375 6.706Z",
    fill: "url(#paint23_radial_116_5203)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0244 3.43677V9.97523L15.6734 6.706C15.3347 6.25659 14.9566 5.83827 14.5436 5.456C14.1563 5.04815 13.7384 4.67046 13.2936 4.3262C12.7719 4.10682 12.2333 3.92995 11.683 3.79735C11.1411 3.63146 10.5863 3.51085 10.0244 3.43677Z",
    fill: "url(#paint24_radial_116_5203)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6734 6.70679L10.0244 9.97602L15.6734 13.2452C15.8928 12.7235 16.0697 12.1849 16.2023 11.6347C16.3503 11.0882 16.4707 10.5346 16.5629 9.97602C16.4707 9.41742 16.3503 8.86383 16.2023 8.31737C16.0697 7.76714 15.8928 7.22852 15.6734 6.70679Z",
    fill: "url(#paint25_radial_116_5203)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6734 13.2448L10.0244 9.97559V16.514C10.5842 16.439 11.1383 16.3265 11.683 16.1775C12.2301 16.0339 12.768 15.8573 13.2936 15.6487C13.7023 15.3362 14.183 14.8554 14.5436 14.5189C14.9511 14.1226 15.3287 13.6967 15.6734 13.2448Z",
    fill: "url(#paint26_radial_116_5203)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.024 16.514V9.97559L4.375 13.2448C5.07718 14.1394 5.88424 14.9465 6.77884 15.6487C7.30324 15.8608 7.84131 16.0375 8.38942 16.1775C8.93371 16.3285 9.48797 16.441 10.0481 16.514H10.024Z",
    fill: "url(#paint27_radial_116_5203)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0238 3.43677C9.48735 3.50944 8.95703 3.62194 8.43727 3.77331L3.79783 8.38869C3.65906 8.91013 3.5547 9.44012 3.48535 9.97523C3.55842 10.5353 3.67087 11.0896 3.82189 11.6339C3.96545 12.1809 4.14206 12.7188 4.35074 13.2445L4.68727 13.6772L13.7017 4.66273L13.293 4.3262C12.7713 4.10682 12.2327 3.92995 11.6824 3.79735C11.1405 3.63146 10.5857 3.51085 10.0238 3.43677Z",
    fill: "url(#paint28_radial_116_5203)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9857 7.54858L7.57227 16.0342L8.36554 16.2745C8.79314 16.3923 9.22636 16.4886 9.6636 16.563L16.5146 9.71204C16.5146 9.27935 16.2982 8.79859 16.2021 8.41397C16.1059 8.02935 16.0578 7.90915 15.9857 7.64473V7.54858Z",
    fill: "url(#paint29_radial_116_5203)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0244 1.34595C9.27775 1.43693 8.53863 1.58153 7.81279 1.77864C7.09271 1.97268 6.3861 2.21358 5.69743 2.49979C5.09862 2.95206 4.53602 3.45037 4.01475 3.99018C3.47402 4.5036 2.98305 5.067 2.5484 5.67287C2.24042 6.35311 1.9989 7.06154 1.82724 7.78825C1.60919 8.50086 1.46419 9.2338 1.39453 9.97575C1.4658 10.7254 1.61075 11.4661 1.82724 12.1873C2.00298 12.9128 2.24436 13.6209 2.5484 14.3027C2.98305 14.9085 3.47402 15.4719 4.01475 15.9854C4.53469 16.5193 5.09746 17.0097 5.69743 17.4517C6.38194 17.7488 7.08935 17.99 7.81279 18.1729C8.53583 18.3818 9.2759 18.5266 10.0244 18.6056C10.7645 18.5239 11.4963 18.3791 12.2118 18.1729C12.9353 17.99 13.6427 17.7488 14.3272 17.4517C14.9272 17.0097 15.49 16.5193 16.0099 15.9854C16.5506 15.4719 17.0416 14.9085 17.4763 14.3027C17.7803 13.6209 18.0217 12.9128 18.1974 12.1873C18.4139 11.4661 18.5588 10.7254 18.6301 9.97575C18.5604 9.2338 18.4155 8.50086 18.1974 7.78825C18.0258 7.06154 17.7842 6.35311 17.4763 5.67287C17.0416 5.067 16.5506 4.5036 16.0099 3.99018C15.4886 3.45037 14.926 2.95206 14.3272 2.49979C13.6386 2.21358 12.9319 1.97268 12.2118 1.77864C11.4935 1.58419 10.7626 1.43962 10.0244 1.34595Z",
    fill: "url(#paint30_radial_116_5203)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.024 9.97599) scale(9.97596)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#4B0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#430202",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.3315 3.29254) scale(13.2692 13.2692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB2E8C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.03343 2.86058) scale(13.2452 13.2452)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9DCF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.56303 -0.264632) scale(8.02886 8.02885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1206 6.77825) scale(11.7788 11.7788)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9DCF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.4516 21.129) scale(9.25475 9.2548)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.63922 9.47078) scale(10.1923 10.1923)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.7979 11.4902) scale(15.1201 15.1202)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.73051 11.1298) scale(15.7691 15.7692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB2E8C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1206 8.89403) scale(8.17304 8.17309)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB2E8C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.3944 13.0282) scale(8.17309 8.17307)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30A76"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.0963778 20.1434) scale(8.34134)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB2E8C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.50936 13.99) scale(10.0722 10.0721)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB2E8C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.87473 3.19689) scale(8.91835 8.91827)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.30746 4.71154) scale(5.64904)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.02437 6.68247) scale(6.12986 6.12981)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.07724 9.51885) scale(5.19235 5.19231)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9757 13.0521) scale(3.72594 3.72596)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4902 9.99962) scale(3.94229 3.9423)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.37 10.4077) scale(5.14421 5.14423)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.41842 4.90385) scale(3.02883 3.02885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.4855 13.9657) scale(3.41346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.85014 8.31736) scale(12.7404 12.7404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.64423 2.54734) scale(9.59134 9.59135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8946 -4.30362) scale(26.2258 26.226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5388 3.53371) scale(10.2404 10.2404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5725 20.4323) scale(12.8605 12.8606)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.91346 19.3746) scale(13.2211 13.2212)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.3892 -5.91419) scale(22.0192 22.0192)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8751 -2.0668) scale(19.2067 19.2067)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_116_5203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.58203 1.4421) scale(13.7259 13.726)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGemPink);
export default __webpack_public_path__ + "static/media/icon-gem-pink.f0535db7061216276495a56b554e31b6.svg";
export { ForwardRef as ReactComponent };